<div class="login" *ngIf="!loading">
    <div class="animated fadeInRight" *ngIf="!loading">
        <div class="app-body">
            <main class="main d-flex align-items-center">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-sm-10 col-md-8 mx-auto">
                            <div class="card-group border border-warning">
                                <div class="card text-black-50 bg-light border-warning py-5 d-md-down-none"
                                    style="width:100%">
                                    <div class="card-body text-center">
                                        <div>
                                            <object>
                                                <embed src="../../../../../assets/images/logo/lafabril-logo-medium.svg">
                                            </object>
                                        </div>
                                    </div>
                                </div>
                                <div class="card border-warning p-4">
                                    <div class="card-body">
                                        <form [formGroup]="formulario" novalidate class="form-group" (ngSubmit)="onSolicitarRecuperacion()">
                                            <h3 class="card-title">Recuperación de Contraseña</h3>
                                            <p class="text-muted">Ingrese su usuario y correo electrónico para restablecer su contraseña</p>

                                            <div class="input-group mb-4 mt-4">
                                                <span class="input-group-text"> <i class="fa fa-user"
                                                        aria-hidden="true"></i> </span>
                                                <input class="form-control" type="text" placeholder="Usuario"
                                                    formControlName="username">
                                            </div>
                                            <div class="input-group mb-4">
                                                <span class="input-group-text"> <i class="fa fa-envelope"
                                                        aria-hidden="true"></i> </span>
                                                <input class="form-control" type="email" placeholder="Correo Electrónico"
                                                    formControlName="email">
                                            </div>

                                            <div class="row">
                                                <div class="col-6">
                                                    <button type="submit" class="btn btn-outline-warning px-4 ngcl"
                                                        [disabled]="formulario.invalid">Enviar</button>
                                                </div>
                                            </div>
                                            <br>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <a (click)="volverAlLogin()" style="cursor: pointer;">Volver al Login</a>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</div>

<div class="containerLoader" *ngIf="loading">
    <div class="item-1"></div>
    <div class="item-2"></div>
    <div class="item-3"></div>
    <div class="item-4"></div>
    <div class="item-5"></div>
</div>
